import { fetcher } from '@commenda/utils';

import { FileGetResponse } from './types';

export async function getFile(
  fileId: string,
  corporationId: number
): Promise<{
  success: boolean;
  data?: FileGetResponse;
  error?: string;
}> {
  try {
    const response = await fetcher(
      `new-sales-tax/file/${fileId}?corporation_id=${corporationId}`,
      {
        method: 'GET',
      },
      undefined
    );

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        error: data.message || 'Failed to get file',
      };
    }

    return {
      success: true,
      data,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'An unexpected error occurred',
    };
  }
}
